import {
  EDIT_MODE_ON,
  EDIT_MODE_OFF,
  HIDE_BAR,
  SHOW_BAR,
  UI_START_LOADING,
  UI_STOP_LOADING,
  LIST_PULL_REFRESHING_ON,
  LIST_PULL_REFRESHING_OFF,
  SET_UI_FLAG
} from "../actions/actionTypes";
import { logger } from "../../app/utils/utils";

const initialState = {
  showSpinner: false,
  showMenuButton: false,
  editMode: false,
  pullRefresh: false,
  showSelectorProjects: false,
  showSelectorUsers: false,
  showSelectorPhases: false,
  operationType: "",
  id4photos: "",
  notLoggedIn: true,
  loginProgress: true,
  workerMenus: [
    {
      displayToggle: "YES",
      menuCaption: "BCS HOME",
      menuIcon: "fa fa-home",
      mobileRecLimit: "",
      recLimit: "",
      tableCaption: "BCS HOME",
      tableName: "bcsHome"
    },
    {
      menuCaption: "ORDERS",
      menuIcon: "fa fa-shopping-cart",
      mobileRecLimit: "",
      recLimit: "",
      tableCaption: "DELIVERY REQUEST",
      tableName: "deliveryRequest"
    },
    {
      menuCaption: "OPEN BAZAR",
      menuIcon: "fa fa-users",
      mobileRecLimit: "",
      recLimit: "",
      tableCaption: "OPEN BAZAR",
      tableName: "openBazar"
    },
    {
      menuCaption: "SIGN OUT",
      menuIcon: "fa fa-sign-out",
      mobileRecLimit: "",
      recLimit: "",
      tableCaption: "SIGN OUT",
      tableName: "signout"
    }
  ],
  userMenus: [
    {
      displayToggle: "YES",
      menuCaption: "BCS HOME",
      menuIcon: "fa fa-home",
      mobileRecLimit: "",
      recLimit: "",
      tableCaption: "BCS HOME",
      tableName: "bcsHome"
    },
    {
      displayToggle: "YES",
      menuCaption: "SUPPLIER",
      menuIcon: "fa fa-th-list",
      mobileRecLimit: "",
      recLimit: "",
      tableCaption: "SUPPLIER",
      tableName: "dqr"
    },
    {
      menuCaption: "MY SHOP",
      menuIcon: "fa fa-check-circle",
      mobileRecLimit: "",
      recLimit: "",
      tableCaption: "MY SHOP",
      tableName: "supplierShopItems"
    },
    {
      menuCaption: "OPEN BAZAR",
      menuIcon: "fa fa-users",
      mobileRecLimit: "",
      recLimit: "",
      tableCaption: "OPEN BAZAR",
      tableName: "openBazar"
    },
    {
      displayToggle: "YES",
      menuCaption: "SIGN OUT",
      menuIcon: "fa fa-sign-out",
      mobileRecLimit: "",
      recLimit: "",
      tableCaption: "SIGN OUT",
      tableName: "signout"
    }
  ]
};

const uiReducer = (state = initialState, action) => {
  switch (action.type) {
    case UI_START_LOADING:
      logger("FULL", "uiReducer", "starting spinner");
      return {
        ...state,
        showSpinner: true
      };
    case UI_STOP_LOADING:
      logger("FULL", "uiReducer", "Stopping spinner");
      return {
        ...state,
        showSpinner: false
      };
    case SHOW_BAR:
      return {
        ...state,
        showMenuButton: true
      };
    case HIDE_BAR:
      return {
        ...state,
        showMenuButton: false
      };
    case EDIT_MODE_ON:
      return {
        ...state,
        editMode: true
      };
    case EDIT_MODE_OFF:
      return {
        ...state,
        editMode: false
      };
    case LIST_PULL_REFRESHING_ON:
      return {
        ...state,
        pullRefresh: true
      };
    case LIST_PULL_REFRESHING_OFF:
      return {
        ...state,
        pullRefresh: false
      };

    case SET_UI_FLAG:
      let newState = { ...state };
      newState[action.flagName] = action.status;

      return {
        ...newState
      };

    default:
      return state;
  }
};

export default uiReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/ui.js